.section {
  display: flex;
  flex-direction: column;
  gap: 1.15rem;
}

.summaryStrip {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 0.9rem;
  background: var(--bg-surface);
  border: 1px solid var(--border-subtle);
  border-radius: var(--radius-lg);
  padding: 1rem 1.25rem;
}

.stripItem {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  border-right: 1px solid var(--border-subtle);
  padding-right: 0.9rem;
}

.stripItem:last-child {
  border-right: none;
  padding-right: 0;
}

.stripLabel {
  font-size: 0.75rem;
  color: var(--text-secondary);
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.stripValue {
  font-family: var(--font-mono);
  font-size: 1.15rem;
  font-weight: 700;
  color: var(--text-primary);
  font-variant-numeric: tabular-nums;
}

.stripHint {
  font-size: 0.74rem;
  color: var(--text-muted);
  font-variant-numeric: tabular-nums;
}

.kpiGrid {
  display: grid;
  grid-template-columns: repeat(12, minmax(0, 1fr));
  gap: 1rem;
}

.card {
  background: var(--bg-surface);
  border: 1px solid var(--border-subtle);
  border-radius: var(--radius-lg);
  padding: 1.2rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 0.75rem;
  box-shadow: var(--shadow-card);
  position: relative;
  overflow: hidden;
}

.heroCard {
  grid-column: span 4;
  background: linear-gradient(145deg, #eff4ff 0%, #ffffff 80%);
  border-color: var(--border-highlight);
}

.standardCard {
  grid-column: span 4;
}

.compactCard {
  grid-column: span 3;
}

.cardHeader {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
}

.kpiCode {
  font-family: var(--font-mono);
  font-size: 0.7rem;
  font-weight: 700;
  padding: 0.18rem 0.5rem;
  border-radius: 6px;
  background: #eff4ff;
  border: 1px solid #dce9ff;
  color: #00236f;
}

.kpiFormula {
  font-family: var(--font-mono);
  font-size: 0.72rem;
  color: var(--accent-info);
}

.cardTitle {
  font-size: 0.86rem;
  font-weight: 600;
  color: var(--text-secondary);
}

.metricPrimary {
  font-family: var(--font-mono);
  font-size: 1.85rem;
  font-weight: 700;
  letter-spacing: -0.03em;
  color: var(--text-primary);
  font-variant-numeric: tabular-nums;
}

.metricHero {
  font-family: var(--font-mono);
  font-size: 2.2rem;
  font-weight: 700;
  letter-spacing: -0.03em;
  color: var(--accent-primary);
  font-variant-numeric: tabular-nums;
}

.metricSubRow {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  padding-top: 0.55rem;
  border-top: 1px solid var(--border-subtle);
  font-size: 0.78rem;
  color: var(--text-secondary);
  font-variant-numeric: tabular-nums;
}

.pillOptimal {
  padding: 0.18rem 0.55rem;
  border-radius: 999px;
  font-family: var(--font-mono);
  font-size: 0.72rem;
  font-weight: 600;
  background: var(--accent-primary-dim);
  color: var(--accent-primary);
}

.pillOnTrack {
  padding: 0.18rem 0.55rem;
  border-radius: 999px;
  font-family: var(--font-mono);
  font-size: 0.72rem;
  font-weight: 600;
  background: var(--accent-info-dim);
  color: var(--accent-info);
}

.pillWarning {
  padding: 0.18rem 0.55rem;
  border-radius: 999px;
  font-family: var(--font-mono);
  font-size: 0.72rem;
  font-weight: 600;
  background: var(--status-warning-dim);
  color: var(--status-warning);
}

.pillCritical {
  padding: 0.18rem 0.55rem;
  border-radius: 999px;
  font-family: var(--font-mono);
  font-size: 0.72rem;
  font-weight: 600;
  background: var(--status-danger-dim);
  color: var(--status-danger);
}

.textPositive {
  color: var(--accent-primary);
  font-weight: 600;
}

.textWarning {
  color: var(--status-warning);
  font-weight: 600;
}

.textDanger {
  color: var(--status-danger);
  font-weight: 600;
}

@media (max-width: 1120px) {
  .summaryStrip {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .heroCard,
  .standardCard,
  .compactCard {
    grid-column: span 6;
  }
}

@media (max-width: 900px) {
  .summaryStrip {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    padding: 0.85rem 0.95rem;
    gap: 0.75rem;
  }

  .stripItem {
    border-right: none;
    padding-right: 0;
  }

  .kpiGrid {
    grid-template-columns: minmax(0, 1fr);
    gap: 0.8rem;
  }

  .heroCard,
  .standardCard,
  .compactCard {
    grid-column: 1 / -1;
    padding: 0.95rem 1rem;
    min-width: 0;
  }

  .metricHero {
    font-size: 1.65rem;
    word-break: break-word;
  }

  .metricPrimary {
    font-size: 1.42rem;
    word-break: break-word;
  }

  .metricSubRow {
    flex-wrap: wrap;
    gap: 0.35rem;
  }
}

@media (max-width: 560px) {
  .summaryStrip {
    grid-template-columns: minmax(0, 1fr);
  }

  .stripItem {
    border-bottom: 1px solid var(--border-subtle);
    padding-bottom: 0.55rem;
  }
}
